import { ManageActionPanel } from "@/overlay/components/LayerStackWindow/ManageActionPanel/ManageActionPanel";
import { TephigramOptionsPanel } from "@/overlay/components/LayerStackWindow/TephigramOptionsPanel";
import { useAppDispatch } from "@/reducer";
import { setTephigramTitle } from "@/reducer/TephigramState";
import { t } from "@lingui/core/macro";
import type { TephigramSchemaOutput } from "@mm/metx-workbench.meteomatics.com";
import { EditableTextbox } from "../../CommonParts/EditableTextbox";

interface TephigramSettingProps {
  tephigram: TephigramSchemaOutput;
  clearTephigram: () => void;
}

export function TephigramSetting({ tephigram, clearTephigram }: TephigramSettingProps) {
  const dispatch = useAppDispatch();

  return (
    <>
      <div className="title-row">
        <EditableTextbox
          className={"editable-map-title"}
          value={tephigram.title ?? ""}
          placeholder={tephigram.title === "" ? t`Untitled Table` : undefined}
          blurOnEnterKey
          onSave={(newTitle) => {
            dispatch(setTephigramTitle({ id: tephigram.id, title: newTitle }));
          }}
        />
        <ManageActionPanel onRemove={clearTephigram} />
      </div>
      <TephigramOptionsPanel title={t`Tephigram`} tephigram={tephigram} />
    </>
  );
}
